/** Short browser name for user-facing hints ("Firefox", "Brave"…), or null. */
export function browserName(): string | null {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent;
  if ('brave' in navigator) return 'Brave';
  if (/SamsungBrowser/i.test(ua)) return 'Samsung Internet';
  if (/Firefox|FxiOS/i.test(ua)) return 'Firefox';
  if (/OPR\/|Opera/i.test(ua)) return 'Opera';
  if (/DuckDuckGo/i.test(ua)) return 'DuckDuckGo';
  if (/Edg\//i.test(ua)) return 'Edge';
  if (/Chrome\//i.test(ua)) return 'Chrome';
  if (/Safari\//i.test(ua)) return 'Safari';
  return null;
}

/** Running as the installed PWA (home screen / app window), not in a browser tab. */
export function isInstalledApp(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(display-mode: standalone)').matches;
}
